module.exports = __webpack_public_path__ + "img/GH-kyujin-koukoku002.eda76adf.webp";